// Registro central de tools. Mapeia toolId → role (worker que vai executar).
// Cada tool em src/tools/{id}/index.ts é importado em "_all.ts" e registrado
// no registry global do worker pra dispatch.

import type { WorkerRole } from "../runtime/types.ts";

export const TOOL_ROLES: Record<string, WorkerRole> = {
  ocr: "tesseract",
  tags: "mobilenet",
  caption: "caption",
  "zero-shot-image": "clip",
  embeddings: "clip",
  "zero-shot-text": "text",
  sentiment: "text",
  summarize: "text",
  translate: "text",
  "language-detect": "text",
  ner: "text",
  "text-embeddings": "text",
  transcribe: "whisper",
  extract: "extractor",
  "extract-images": "extractor",
  suggest: "extractor",
  diagnose: "extractor",
  "detect-objects": "vision",
  "face-detection": "face",
  "facial-emotion": "face",
  "age-estimation": "face",
  "perceived-gender": "face",
  "facial-attributes": "face",
  "eye-state": "face",
  "head-pose": "face",
  "gaze-direction": "face",
  "face-liveness": "face",
  "pose-estimation": "pose",
  "hand-landmarks": "hand",
  "person-segmentation": "seg",
  "person-reid": "reid",
  "face-blur": "face",
  "face-embedding": "face",
  "minor-detection": "face",
};
